import {configureStore} from '@reduxjs/toolkit';
import {AuthReducer} from "../auth/AuthReducer";
import {ToastReducer} from "../validation/ToastReducer";
import {LayoutReducer} from "../view/LayoutReducer";
import {DevicesPageReducer} from "../devices/DevicesPageReducer";
import {AddDeviceModalReducer} from "../devices/add-device-modal/AddDeviceModalReducer";
import {ValidationReducer} from "../validation/ValidationReducer";
import {ValidatePageReducer} from "../rules/validate/ValidatePageReducer";
import {ViolationsPageReducer} from "../violations/ViolationsPageReducer";
import {MsbPageReducer} from "../rules/msb/MsbPageReducer";
import {ReportsPageReducer} from "../reports/ReportsPageReducer";
import {DeviceDetailsPageReducer} from "../devices/details/DeviceDetailsPageReducer";
import {ChangeDetailsPageReducer} from "../devices/change-details/ChangeDetailsPageReducer";
import {BaselinePageReducer} from "../devices/baseline/BaselinePageReducer";
import {AnalysisPageReducer} from "../rules/analysis/AnalysisPageReducer";
import {RecentViolationsPageReducer} from "../recentviolations/RecentViolationsPageReducer";
import {AddRulesPageReducer} from "../rules/add-rules/AddRulesPageReducer";
import {LicensePageReducer} from "../license/LicensePageReducer";
import {AuthPageReducer} from "../auth/AuthPageReducer";
import {AlertNotificationPageReducer} from "../alert/AlertNotificationPageReducer";
import {SystemPageReducer} from "../system/SystemPageReducer";
import {MlDetectionPageReducer} from "../mllogincountdetectionresults/MlDetectionPageReducer";
import {ParametersPageReducer} from "../rules/parameters/ParametersPageReducer";
import {ConfigChangesPageReducer} from "../devices/config-changes/ConfigChangesPageReducer"
import {RemediationPageReducer} from "../rules/remediation/RemediationPageReducer";
import { SystemSettingsPageReducer } from '../system/system-settings/SystemSettingsPageReducer';
import { VulscanPageReducer } from '../networkscan/vulnerabilityscan/VulscanPageReducer';
import { InventoryPageReducer } from '../networkscan/networkinventory/InventoryPageReducer';
import { DeviceAuthorizationPageReducer } from '../devices/authorization/DeviceAuthorizationPageReducer';

export default configureStore({
    reducer: {
        auth: AuthReducer,
        toast: ToastReducer,
        layout: LayoutReducer,
        devicesPage: DevicesPageReducer,
        addDeviceModal: AddDeviceModalReducer,
        validatePage: ValidatePageReducer,
        violationsPage: ViolationsPageReducer,
        msbPage: MsbPageReducer,
        reportsPage: ReportsPageReducer,
        mlDetectionPage: MlDetectionPageReducer,
        deviceDetailsPage: DeviceDetailsPageReducer,
        changeDetailsPage: ChangeDetailsPageReducer,
        baselinePage: BaselinePageReducer,
        analysisPage: AnalysisPageReducer,
        recentViolationsPage: RecentViolationsPageReducer,
        addRulesPage: AddRulesPageReducer,
        validation: ValidationReducer,
        licensePage: LicensePageReducer,
        authPage: AuthPageReducer,
        alertPage: AlertNotificationPageReducer,
        systemPage: SystemPageReducer,
        parametersPage: ParametersPageReducer,
        configChangesPage: ConfigChangesPageReducer,
        remediationPage: RemediationPageReducer,
        systemSettingsPage: SystemSettingsPageReducer,
        vulscanPage: VulscanPageReducer,
        inventoryPage: InventoryPageReducer,
        deviceAuthorizationPage: DeviceAuthorizationPageReducer
    },
});
